export default [
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Requisite data',
    },
    cell: {
      type: 'slot',
      name: 'requisiteData',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Payment method',
    },
    cell: {
      type: 'slot',
      name: 'paymentMethod',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Trader Login',
    },
    cell: {
      type: 'slot',
      name: 'traderLogin',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Creation date',
    },
    cell: {
      type: 'slot',
      name: 'createdAt',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Turnover',
    },
    cell: {
      type: 'slot',
      name: 'turnover',
    },
  },
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Conversion by transaction',
    },
    cell: {
      type: 'slot',
      name: 'conversion',
    },
  },
];
